import request from '@/utils/request'

/** 商品列表 */
export function getProductList(typeId, isUp, keyword, page = 1, size = 10) {
  return request({
    url: '/manage/product/list',
    method: 'get',
    params: { typeId, isUp, keyword, page, size }
  })
}

/** 商品详情 */
export function getProductDetail(id) {
  return request({
    url: `/manage/product/detail/${id}`,
    method: 'get'
  })
}

/** 上架/下架 */
export function toggleProduct(id) {
  return request({
    url: `/manage/product/toggle/${id}`,
    method: 'post'
  })
}

/** 强制下架 */
export function forceDownProduct(id, reason) {
  return request({
    url: `/manage/product/force-down/${id}`,
    method: 'post',
    data: { reason }
  })
}
